import { useEffect, useState, RefObject } from 'react'

export const useIntersectionObserver = (
  element: RefObject<HTMLElement | null>,
  shouldObserve: boolean | undefined,
  threshold?: number,
  unset?: boolean,
) => {
  const DEFAULT_THRESHOLD = 0.9
  const [isIntersecting, setIsIntersecting] = useState(false)
  const configuredThreshold = threshold || DEFAULT_THRESHOLD
  const defaultOptions = {
    root: null,
    rootMargin: '0px',
    threshold: configuredThreshold,
  }

  const callback: IntersectionObserverCallback = entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio >= configuredThreshold) {
        setIsIntersecting(true)
      } else if (unset) {
        setIsIntersecting(false)
      }
    })
  }

  useEffect(() => {
    const observer = new IntersectionObserver(callback, defaultOptions)

    if (shouldObserve && element.current) {
      observer.observe(element.current)
    }

    return () => {
      // oxlint-disable-next-line react-hooks/exhaustive-deps
      if (shouldObserve && element.current) {
        // oxlint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(element.current)
      }
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldObserve, element])

  return isIntersecting
}
